import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; 

let db = false;

export const getDb = () => {
    if(!db){
        const firebaseConfig = {
            apiKey: "AIzaSyBzYhNeI39XhZHU_ntOHafOlp4ehmQSQ_4",
            authDomain: "iotclub-vnr.firebaseapp.com",
            projectId: "iotclub-vnr",
            storageBucket: "iotclub-vnr.appspot.com",
            messagingSenderId: "1018071172625",
            appId: "1:1018071172625:web:1f48d4e68e5563bec2d3b0",
            measurementId: "G-FKKWEPWK9X"
        }

        const app = initializeApp(firebaseConfig)

        db = getFirestore(app)
    }

    return db
}